import * as ReportingRead from '../../Apis/ReportingReadApi';
import AppConstants from '../../AppConstants';
import { delay } from 'redux-saga';
import { all, call, fork, put, takeLatest, select, race, take } from 'redux-saga/effects';
import * as Actions from './ReportsActions';
import { forceLoginIfExpired } from '../Utils/RedirectionUtils';
import { ReportType } from '../../Utils/Constants';

export function* getGenerateReportWatcher() {
  yield takeLatest(Actions.GENERATE_REPORT_STARTED, getGenerateReport);
}

export function* getGenerateReport(action) {
  try {
    const { reportType, reportFormatType, keys, user, sendEmail } = action.payload;
    const generateReportResponse = yield call(
      ReportingRead.submitReportJob,
      reportType,
      reportFormatType,
      keys,
      user,
      sendEmail
    );
    const jobId = generateReportResponse.data.id;
    if (sendEmail) {
      yield put({
        type: Actions.GENERATE_REPORT_COMPLETED,
        payload: { jobId, sendEmail }
      });
      return jobId;
    }

    while (true) {
      const { pollJob, pauseJob } = yield race({
        pollJob: call(pollGenerateReport, jobId, reportType),
        pauseJob: take(Actions.GENERATE_REPORT_TRIGGER_PAUSED)
      });

      if (pauseJob) {
        yield put({
          type: Actions.GENERATE_REPORT_PAUSED
        });
        const { cancelJob } = yield race({
          resumeJob: take(Actions.GENERATE_REPORT_RESUMED),
          cancelJob: take(Actions.GENERATE_REPORT_CANCELLED)
        });

        if (cancelJob) {
          break;
        }
      } else {
        switch (pollJob) {
          case Actions.ReportStatus.COMPLETED:
            let downloadUrl = state => state.reduced_reports.url;
            window.location = yield select(downloadUrl);
            break;
          case Actions.ReportStatus.FAILED:
            yield put({
              type: Actions.GENERATE_REPORT_FAILED
            });
            break;
          case Actions.ReportStatus.DELAYED:
            yield put({
              type: Actions.GENERATE_REPORT_DELAYED
            });
            break;
          default:
            break;
        }
        break;
      }
    }
  } catch (error) {
    yield put({ type: Actions.GENERATE_REPORT_FAILED, error });
    forceLoginIfExpired(error);
  }
}
export function* pollGenerateReport(jobId, reportType) {
  try {
    let sendEvent = false;
    const retryCount = AppConstants.REPORT_GENERATION_RETRY_COUNT;
    for (let i = 0; i < retryCount; i++) {
      if (i === retryCount - 1) {
        sendEvent = true;
      }
      if (!(i === 0)) {
        yield call(delay, 1000);
      }
      let jobResponse = yield call(ReportingRead.checkJobStatus, jobId, sendEvent, reportType);

      switch (jobResponse.data.status) {
        case Actions.ReportStatus.STARTED:
          continue;
        case Actions.ReportStatus.SUBMITTED:
          continue;
        case Actions.ReportStatus.COMPLETED:
          let url = null;

          if (
            reportType === ReportType.VIRTUAL_EVENT_REGISTRATION_REPORT ||
            reportType === ReportType.VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT
          ) {
            url = jobResponse.data.output;
          } else {
            url = JSON.parse(jobResponse.data.output).url;
          }
          yield put({
            type: Actions.GENERATE_REPORT_COMPLETED,
            payload: { url }
          });

          return Actions.ReportStatus.COMPLETED;
        case Actions.ReportStatus.FAILED:
          return Actions.ReportStatus.FAILED;
        default:
          break;
      }
      break;
    }
    if (sendEvent) {
      return Actions.ReportStatus.DELAYED;
    }
  } catch (error) {
    yield put({ type: Actions.GENERATE_REPORT_FAILED, error });
    // forceLoginIfExpired(error);
  }
}

export default function* rootSaga() {
  yield all([fork(getGenerateReportWatcher)]);
}



// WEBPACK FOOTER //
// ./src/Reducks/Reports/ReportsSagas.js